import { LitElement, css, html, PropertyValues } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';
import "./echarts-component"


@customElement('voyage-distance-deviation-overview')
export class VoyageDistanceDeviationOverview extends LitElement {
    constructor() {
        super();

    }
    @property({ attribute: false }) private _maximized: boolean = false;
    static get styles() {
        return [
            css`
            :host {
                display: flex;
                flex-direction: column;
                max-height: calc(100vh - 179px);
            }
            .chart-container {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
                width: 390px;
                overflow-x: hidden;
                overflow-y: auto;
                max-height: calc(100vh - 277px);
            }

            .chart-container[maximized] {
                width: calc(100vw - 412px);
                max-height: calc(100vh - 220px);
            }

            .chart {
                flex-grow: 1;
            }

            .expand {
                position: absolute;
                top: 31px;
                right: 59px;
                fill: var(--neutrals-grey-02, black);
                cursor: pointer;
            }

            .expand > svg {
                display: block;
                height: 15px;
            }

        `];
    }

    render() {
        return html`
            <div class="list">
                <span
                    class="expand"
                    title="${this._maximized ? 'Minimize distance deviation' : 'Maximize distance deviation'}"
                    @click=${() => { this.setMaximized() }}>${this._maximized ? SvgIcons.solidCompressArrowsAlt : SvgIcons.expandPageIcon}
                </span>
             <div clas="chart-container" ?maximized=${this._maximized}>
             <echarts-component></echarts-component>
             </div>
            </div>
        `;
    }

    setMaximized() {
        this._maximized = !this._maximized;
    }

}